export const VERSION = `v=${Date.now()}`;